import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import {
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material'
import Typography from '@mui/material/Typography'
import dayjs from 'dayjs'
import { DATE_FORMAT_FULL } from '../../../../../../../constants/global'

export interface IFilterMapped {
  page?: number
  perPage?: number
  startDate?: string
  endDate?: string
  view?: EViewType
}

interface FilterGroupProps {
  onDateNext: () => void
  onDatePrev: () => void
  onViewChange: (value: EViewType) => void
  date: string | Date
  view: EViewType
}

export enum EViewType {
  DAY = 'timeGridDay',
  WEEK = 'timeGridWeek',
  MONTH = 'dayGridMonth',
}

const menuItemsTypeView = [
  // {
  //   label: 'วัน',
  //   value: EViewType.DAY,
  // },
  // {
  //   label: 'สัปดาห์',
  //   value: EViewType.WEEK,
  // },
  {
    label: 'เดือน',
    value: EViewType.MONTH,
  },
]

const CalendarFilter = ({
  date,
  view,
  onDateNext,
  onDatePrev,
  onViewChange,
}: FilterGroupProps) => {
  let dateType = 'MMMM YYYY'

  if (view === EViewType.DAY) {
    dateType = 'DD MMMM YYYY'
  }

  return (
    <Grid
      container
      spacing={2}
      mb={2}
      alignItems={'center'}
      justifyContent={'space-between'}
    >
      <Grid item>
        <Typography variant={`h5`}>
          {dayjs(date).format(dateType)}
        </Typography>
      </Grid>
      <Grid item>
        <Grid container spacing={2} alignItems={'flex-end'}>
          <Grid item>
            <IconButton onClick={onDatePrev}>
              <KeyboardArrowLeftIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <IconButton onClick={onDateNext}>
              <KeyboardArrowRightIcon />
            </IconButton>
          </Grid>
          <Grid item>
            <FormControl variant="filled" fullWidth sx={{ width: 150 }}>
              <InputLabel id="view-label">View</InputLabel>
              <Select
                id="view"
                name="view"
                labelId="view-label"
                defaultValue={view ?? undefined}
                onChange={(e) => onViewChange(e?.target.value as EViewType)}
                fullWidth
              >
                <MenuItem disabled value="" selected>
                  <em>เลือกงานมองเห็น</em>
                </MenuItem>
                {menuItemsTypeView.map((item, index: number) => (
                  <MenuItem value={item.value} key={index}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CalendarFilter
